<template>
  <div style="width: 100%">
    <div class="table-header">
      <div v-for="(item,index) in columns"
           :key="index"
           class="table-default-item"
           :style="item.width?{ width:getWidth(item.width) }:{ flex: 1}">
        {{ item.title }}
      </div>
    </div>
    <custom-dragging-list
      :data-list="dataList"
      :row-key="rowKey"
      @draggable="onDraggable"
    >
      <div class="item-box" slot-scope="rowItem">
        <div v-for="(item,index) in columns"
             :key="index"
             class="table-default-item"
             :style="item.width?{ width:getWidth(item.width) }:{flex: 1}">
          <slot v-if="item.scopedSlots && item.scopedSlots.customRender" :name=" item.scopedSlots.customRender"
                :record="rowItem.record" :index="rowItem.index"
          ></slot>
          <template v-else> {{ rowItem.record[item.dataIndex] }}</template>
        </div>
      </div>
    </custom-dragging-list>
  </div>
</template>

<script>
import CustomDraggingList from '@/customComponents/CustomDraggingList'

export default {
  name: 'CustomDraggingTable',
  components: { CustomDraggingList },
  props: {
    rowKey: {
      type: String,
      default: '',
      require: true
    },
    dataList: {
      type: Array,
      default: function() {
        return []
      }
    },
    columns: {
      type: Array,
      default: function() {
        return []
      }
    }
  },

  watch: {
    dataList: function(newVal, oldVal) {
      this.tabDataList = newVal
    }
  },
  data() {
    return {
      tabDataList: []
    }
  },

  mounted() {
    this.tabDataList = this.dataList
  },
  methods: {
    onDraggable(dataList) {
      this.tabDataList = dataList
      this.$emit('draggable', this.tabDataList)
    },
    getWidth(width) {
      if (width.endsWith('%') || width.endsWith('px')) {
        return width
      } else {
        return width + 'px'
      }
    }
  }

}
</script>
<style scoped>
.table-header {
  width: 100%;
  height: 54px;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #fafafa;
  box-sizing: border-box;
  padding: 16px;
}

.table-default-item {
  display: inline-block;
}

.item-box {
  padding: 16px;
  box-sizing: border-box;
  border-bottom: 1px solid #E9E9E9;
  display: flex;
  align-items: center;
}
</style>